import React, { useEffect, useState } from "react";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

export const Navigation = (props) => {
  const [links, setLinks] = useState({
    mycard: "/mycard"
  });
  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();

    if (ads || ref) {
      setLinks((prevLinks) => {
        const updated = {};

        Object.keys(prevLinks).forEach((key) => {
          let url;

          try {
            // 如果是完整網址
            url = new URL(prevLinks[key]);
          } catch (e) {
            // 如果是相對路徑，補上 origin
            url = new URL(prevLinks[key], window.location.origin);
          }

          // 分開 set → 不會被 encode 成怪字串
          if (ads) url.searchParams.set("_ads", ads);
          if (ref) url.searchParams.set("ref", ref);

          updated[key] = url.toString();
        });

        return updated;
      });
    }
  }, [props.data]); // 當 props.data 改變時更新連結
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img src="../img/logo.png" alt="logo" className="logo-img" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#hotgame" className="page-scroll">
                熱門遊戲
              </a>
            </li>
            <li>
              <a href="#vip" className="page-scroll">
                超級ＶＩＰ
              </a>
            </li>
            <li>
              <a href="#depost" className="page-scroll">
                儲值優惠
              </a>
            </li>
            <li>
              <a href={links.mycard} className="page-scroll" target="blank">
                MyCard限定優惠
              </a>
            </li>

            <li>
              <a href="https://w2.yhd.tw/shortcut/" className="page-scroll" target="blank">
                建立捷徑
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                portfolio
              </a>
            </li> */}
            {/* <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
